import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

//import components
import PaginationTotal from './PaginationTotal.js';
import PaginationNext from './PaginationNext.js';
import PaginationPrevious from './PaginationPrevious.js';

const Pagination = ({clang, totalPages, currentPage, currentPageState, setNextPage, setPreviousPage, setPageByNum, setCurrentPage, resetPageOnBlur}) => {
    const handleSubmit = (e) => {
        e.preventDefault();
        setPageByNum(currentPageState);
    };

    return (
        <div className="pagination">
            {currentPage > 1 && currentPage <= totalPages && totalPages !== 1 &&
                <PaginationPrevious setPreviousPage={setPreviousPage}/>}
            <div className="pagination__pages">
                <form className="pagination__form" onSubmit={(e) => handleSubmit(e)}>
                    <input className="pagination__input" type="number" min="1" max={totalPages}
                        title={lang[clang].pagination.input}
                        value={currentPageState}
                        onBlur={(event) => resetPageOnBlur(event)}
                        onChange={(event) => setCurrentPage(event)}
                        disabled={totalPages === 1}/>
                    <button title={ lang[clang].title.pagination_btn } type="submit" className="hidden"></button>
                </form>
                <PaginationTotal
                    totalPages={totalPages}
                    currentPage={currentPage}
                    setPageByNum={setPageByNum}/>
            </div>
            {currentPage >= 1 && currentPage < totalPages &&
                <PaginationNext setNextPage={setNextPage}/>}
        </div>
    );
};

Pagination.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(Pagination);



// WEBPACK FOOTER //
// ./src/components/pagination/Pagination.js